// TODO: Node is not copyable, Need to fix

export const embedCard = {
  inline: true,
  group: 'inline',
  selectable: true,
  attrs: {
    url: {
      default: ''
    },
    wrapType: {
      default: 'embed'
    },
    layout: {
      default: 'center'
    },
    width: {
      default: '90%'
    },
    height: {
      default: '500px'
    },
    originalWidth: {
      default: null
    },
    originalHeight: {
      default: null
    }
  },
  parseDOM: [{
    tag: 'a[data-embed-card]',
    priority: 60,
    getAttrs: dom => ({
      url: dom.getAttribute('href'),
      wrapType: dom.getAttribute('data-wrap-type'),
      layout: dom.getAttribute('data-layout') || 'center',
      width: dom.getAttribute('data-width'),
      height: dom.getAttribute('data-height') || 'auto',
      originalWidth: Number(dom.getAttribute('data-original-width')) || null,
      originalHeight: Number(dom.getAttribute('data-original-height')) || null
    })
  }],
  toDOM(node) {
    const {
      url,
      wrapType,
      layout,
      width,
      height,
      originalWidth,
      originalHeight
    } = node.attrs;
    const attrs = {
      href: url,
      'data-embed-card': true,
      'data-wrap-type': wrapType,
      'data-layout': layout,
      'data-width': width,
      'data-height': height,
      'data-original-width': originalWidth,
      'data-original-height': originalHeight
    };
    return ['a', attrs, url];
  }
};